module.exports = __webpack_public_path__ + "static/img/linkedin.8ca3f81e.png";